import { ADMIN_QUEUE_ACTIONS } from '../actions/adminQueueActions';

const initialState = {
  adminQueue: [],
  loading: false,
  error: null,
  assigning: false,
  cancelling: false,
  updatingConfig: false,
  config: {
    automaticNotification: false,
    automaticAssignment: false,
    automaticSearch: false,
    notificationRadius: 10,
    autoAssignmentTimeout: 30,
  }
};

const adminQueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_QUEUE_ACTIONS.FETCH_ADMIN_QUEUE:
      return {
        ...state,
        loading: true,
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.FETCH_ADMIN_QUEUE_SUCCESS:
      return {
        ...state,
        loading: false,
        adminQueue: action.payload,
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.FETCH_ADMIN_QUEUE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case ADMIN_QUEUE_ACTIONS.ASSIGN_DRIVER:
      return {
        ...state,
        assigning: true,
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.ASSIGN_DRIVER_SUCCESS:
      return {
        ...state,
        assigning: false,
        // Remove the assigned booking from admin queue
        adminQueue: state.adminQueue.filter(booking => booking.id !== action.payload.bookingId),
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.ASSIGN_DRIVER_FAILED:
      return {
        ...state,
        assigning: false,
        error: action.payload
      };

    case ADMIN_QUEUE_ACTIONS.CANCEL_TRIP:
      return {
        ...state,
        cancelling: true,
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.CANCEL_TRIP_SUCCESS:
      return {
        ...state,
        cancelling: false,
        // Remove the cancelled booking from admin queue
        adminQueue: state.adminQueue.filter(booking => booking.id !== action.payload.bookingId),
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.CANCEL_TRIP_FAILED:
      return {
        ...state,
        cancelling: false,
        error: action.payload
      };

    case ADMIN_QUEUE_ACTIONS.UPDATE_ADMIN_CONFIG:
      return {
        ...state,
        updatingConfig: true,
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.UPDATE_ADMIN_CONFIG_SUCCESS:
      return {
        ...state,
        updatingConfig: false,
        config: action.payload,
        error: null
      };

    case ADMIN_QUEUE_ACTIONS.UPDATE_ADMIN_CONFIG_FAILED:
      return {
        ...state,
        updatingConfig: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default adminQueueReducer;
